import Vue from 'vue'
import Router from 'vue-router'
// import Brower from '@/utils/Brower'
import { getToken, removeToken } from '@/utils/auth'
import store from "@/store";
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: () => import('../views/layout/index.vue'),
      children: [
        {
          path: '/',
          name: 'index',
          component: () => import('../views/homePage/index.vue'),
          meta: {
            title: '',
            keyword: '',
            description: ''
          }
        },
        {
          path: '/privacy',
          name: 'privacy',
          component: () => import('../views/homePage/privacy.vue'),
          meta: {
            title: '',
            keyword: '',
            description: ''
          }
        },
        {
          path: '/account',
          name: 'account',
          component: () => import('../views/homePage/account.vue'),
          meta: {
            title: '',
            keyword: '',
            description: ''
          }
        }
      ]
    },
    {
      path: '/appprivacy',
      name: 'appPrivacy',
      component: () => import('../views/appPrivacy/index.vue'),
      meta: {
        title: 'FinVui',
        keyword: '',
        description: ''
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { y: 0 }
  }
})

const DEFAULT_TITLE = 'FinVui - Vay Tiền Online Hạn Mức Cao, Duyệt 5 Phút, Minh Bạch'

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
  document.title = to.meta.title || DEFAULT_TITLE
})

router.beforeEach(async (to, from, next) => {
  //next();
  let token = getToken()
  let username = store.state.username
  if (token) {
    if (!username) {
      try {
        await store.dispatch("getUserInfo")
        next()
      } catch (error) {
        removeToken()
        next("/login")
      }
    }
    if (to.path == "/login") {
      next("/")
    }
  } else {
    let toPath = to.path.toLowerCase();
    if (toPath.indexOf("/user") != -1) {
      next("/login?redirect=" + toPath)
    }
    //next()
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js